"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDrep = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var PCredential_1 = require("../../V1/Address/PCredential.js");
exports.PDrep = (0, pstruct_1.pstruct)({
    DRep: { credentials: PCredential_1.PCredential.type },
    AlwaysAbstain: {},
    AlwaysNoConfidence: {}
});
